<template>
<md-toolbar class="md-dense ql-cue-header" v-bind:style="style()">
    <layer-picker :currentLayer="layer" :layers="layers" :editable="editable" @selectLayer="selectLayer" :locked="locked"/>
    <div class="md-body-1 cue-header-title" @click="edit" v-if="editable && !locked" v-show="!editing">{{cue.title}}
        <md-tooltip md-direction="top">Click to edit</md-tooltip>
    </div>
    <div class="md-body-1 cue-header-title" v-else v-show="!editing">{{cue.title}}</div>
    <form novalidate @submit.stop.prevent="submit" v-if="editing" v-on:keyup.stop.prevent="keyPress">
        <md-input-container>
            <md-input v-model="cue.title"></md-input>
            <md-tooltip md-direction="top">Enter to save, Escape to cancel</md-tooltip>
        </md-input-container>
    </form>
    <md-button class="md-icon-button" v-show="!expanded" @click="toggle"><md-icon>keyboard_arrow_down</md-icon></md-button>
    <md-button class="md-icon-button" v-show="expanded" @click="toggle"><md-icon>keyboard_arrow_up</md-icon></md-button>
</md-toolbar>
</template>

<script>
import ProjectCuesLayerPicker from '@/components/project/cues/layer-picker';

/**
 * Component For...
 */
const ProjectCuesCueHeader = {
    name: 'projectCuesCueHeader',
    props: {
        cue: {Object},
        expanded: {Boolean},
        layer: {Object},
        layers: {Array},
        locked: {Boolean},
        editable: {Boolean},
        color: {String}
    },
    data: function() {
        return {
            editing: false,
            oldVal: this.$props.cue.title
        };
    },
    methods: {
        toggle() {
            this.$emit('toggle');
        },
        selectLayer(layer) {
            if (this.locked) {
                return;
            }
            this.$props.cue.layer = layer;
            this.$emit('cueUpdated', this.$props.cue);
        },
        edit() {
            if (this.locked) {
                return;
            }
            this.editing = true;
        },
        keyPress(e) {
            if (e.keyCode === 27) {
                this.editing = false;
                this.$props.cue.title = this.oldVal;
            }
        },
        submit() {
            this.editing = false;
            this.oldVal = this.$props.cue.title;
            this.$emit('cueUpdated', this.cue);
        },
        style() {
            if (this.expanded) {
                return 'border-bottom: 1px solid ' + this.color + '';
            }
            return '';
        }
    },
    components: {
        'layer-picker': ProjectCuesLayerPicker
    }
};

export default ProjectCuesCueHeader;
</script>

<style lang="scss">
.ql-cue-header {
    .cue-header-title {
        flex: 1;
        font-size: 19px;
        font-weight: 400;
    }
}
.md-theme-default.md-toolbar.ql-cue-header {
    background-color: white;
    color: black;
    height: 48px;
    overflow: hidden;
    .md-title, .cue-header-title, form {
        margin-left: 48px;
        background-color: white;
        color: black ;
        .md-input,
        .md-input-focused,
        .md-has-value {
            background-color: white;
            color: black;
            -webkit-text-fill-color: black;
        }
    }
    form {
        flex: 1;
    }
}

.md-theme-show-mode.md-toolbar.ql-cue-header {
    background-color: #424242;
    color: white;
    height: 48px;
    overflow: hidden;
    .md-title, .cue-header-title, form {
        margin-left: 48px;
        background-color: #424242;
        color: white ;
        .md-input,
        .md-input-focused,
        .md-has-value {
            background-color: #424242;
            color: white;
            -webkit-text-fill-color: white;
        }
    }
    form {
        flex: 1;
    }
}
</style>


// WEBPACK FOOTER //
// cue-header.vue?5c5a7cf6